import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-dns",
  templateUrl: "./med-icon-dns.component.html",
})
export class MedIconDnsComponent extends SvgMixinComponent {}
